RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Glance = RivalIQ.apps.Dashboard.views.ColumnWidgets.extend({
        columnWidth: 6,
        panelView: undefined,
        className: 'panel-body',

        dashboardModelEvents: {
            'change': 'reload'
        },

        getPngView: function (child) {
            return child.getView();
        }
    });

    const PostActivityImpressionsView = RivalIQ.views.LayoutView.mixin({
        template: '#insightsPostsActivityAndImpressionsTemplate',
        childView: RivalIQ.apps.Dashboard.views.Widget,

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            normalizeHeights: RivalIQ.apps.Dashboard.mixins.NormalizeHeights
        },

        dashboardModelEvents: {
            change: 'onDashboardModelChanged'
        },

        ui: {
            postsLabel: '.x-posts-label',
            impressionsLabel: '.x-impressions-label'
        },

        regions: {
            summaryMetric: '.x-summary-metric',
            activityChart: '.x-activity-chart',
            impressionsChart: '.x-impressions-chart'
        },

        getActiveIntervalPropName: function () {
            const me = this;
            if (me.getProp('interval')) {
                return 'interval';
            }
            return 'defaultInterval';
        },

        getActivePeriodName: function () {
            const me = this;
            const activeIntervalPropName = me.getActiveIntervalPropName();
            const activeInterval = me.getProp(activeIntervalPropName);
            const period = RivalIQ.utils.timePeriod.interval[activeInterval];
            return period;
        },

        updatePostsLabelText: function () {
            const me = this;

            const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');
            me.ui.postsLabel.text([`${postWord}s Per`, me.getActivePeriodName()].join(' '));
        },

        getImpressionsChartLabel: function () {
            const me = this;
            const period = me.getActivePeriodName();
            let impressionsChartLabel = `Impressions Per ${period}, by Published Day`;
            if (me.getProp('source') !== RivalIQ.enums.sources.INSTAGRAM_INSIGHTS || App.utils.hasInstagramPaidEngagement(me.dashboardModel)) {
                const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');
                impressionsChartLabel = `${postWord} ${impressionsChartLabel}`;
            } else {
                impressionsChartLabel = `Impressions, Organic Per ${period}, by Published Day`;
            }
            return impressionsChartLabel;
        },

        updateImpressionsLabelText: function () {
            const me = this;
            const impressionsLabel = me.getImpressionsChartLabel();
            me.ui.impressionsLabel.text(impressionsLabel);
        },

        onDashboardModelChanged: function (widget) {
            const me = this;

            const activeIntervalPropName = me.getActiveIntervalPropName();
            const currentInterval = widget.get(activeIntervalPropName);
            const previousInterval = _.get(widget, ['_previousAttributes', activeIntervalPropName]);
            if (currentInterval !== previousInterval) {
                me.updatePostsLabelText();
                me.updateImpressionsLabelText();
                return;
            }

            me.reload();
        },

        onIntervalChanged: function (widget, interval) {
            widget.save({
                interval: interval
            });
        },

        onBeforeRenderLoaded: function () {
            const me = this;

            const glance = new Glance({
                dashboardModel: me.dashboardModel,
                collection: new Backbone.Collection(me.dashboardModel.getWidgets().filter(function (widget) {
                    return widget.showInGlance;
                }))
            });

            me.summaryMetric.show(glance);

            const activityWidget = me.dashboardModel.getWidget('post-activity-by-day');
            const impressionsWidget = me.dashboardModel.getWidget('post-impressions-by-day');
            if (activityWidget) {
                me.activityChart.showWidget(activityWidget);
            }
            if (impressionsWidget) {
                me.impressionsChart.showWidget(impressionsWidget);
            }
        },

        serializeData: function () {
            const me = this;
            const impressionsChartLabel = me.getImpressionsChartLabel();

            return {
                impressionsChartLabel: impressionsChartLabel,
                postWord: RivalIQ.data.channels.get(me.getProp('channel')).get('postName')
            };
        },

        templateHelpers: function () {
            const me = this;
            const period = me.getActivePeriodName();
            const activityWidget = me.dashboardModel.getWidget('post-activity-by-day');
            const impressionsWidget = me.dashboardModel.getWidget('post-impressions-by-day');
            return {
                period: period,
                hasPaidEngagement: App.utils.hasInstagramPaidEngagement(me.dashboardModel),
                showActivity: Boolean(activityWidget),
                showImpressions: Boolean(impressionsWidget)
            };
        }
    });

    function filterWidgets(widgets, props) {
        if (props.onlyInstanceIds) {
            widgets = _.filter(widgets, function (widget) {
                return _.includes(props.onlyInstanceIds, widget.instanceId);
            });
        }

        return widgets;
    }

    function getInstagramWidgetDefinitions(dashboardModel, metric) {
        const props = dashboardModel.getProps();

        let impressionsPerDayMetric = 'impressions';
        let dailyImpressionsMetric = 'impressions';
        let dailyImpressionsMetricName = 'Post Impressions';

        if (!App.utils.hasInstagramPaidEngagement(dashboardModel)) {

            impressionsPerDayMetric = 'organic_impressions';
            dailyImpressionsMetric = 'organic_impressions';
            dailyImpressionsMetricName = 'Impressions, Organic';
        }

        const widgets = [
            {
                instanceId: 'summary-metric1',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: 'count'
                }),
                submetric: metric.build({
                    property: 'count',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                }),
                showInGlance: true
            },
            {
                instanceId: 'summary-metric2',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: impressionsPerDayMetric,
                    name: dailyImpressionsMetricName
                }),
                submetric: metric.build({
                    property: impressionsPerDayMetric,
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                }),
                showInGlance: true
            },
            {
                instanceId: 'post-activity-by-day',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_METRIC_BAR_CHART,
                metric: RivalIQ.metric.build(dashboardModel.metric, {
                    property: 'count',
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId', 'postDay']
                }),
                metricDataType: RivalIQ.enums.dataType.INTEGER,
                height: 157,
                labels: {},
                minLeftMargin: 35
            },
            {
                instanceId: 'post-impressions-by-day',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_METRIC_BAR_CHART,
                metric: RivalIQ.metric.build(dashboardModel.metric, {
                    property: dailyImpressionsMetric,
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId', 'postDay'],
                    name: dailyImpressionsMetricName
                }),
                metricDataType: RivalIQ.enums.dataType.INTEGER,
                height: 157,
                labels: {},
                minLeftMargin: 35
            }
        ];

        return filterWidgets(widgets, props);
    }

    function getLinkedInWidgetDefinitions(dashboardModel, metric) {
        const props = dashboardModel.getProps();

        const widgets = [
            {
                instanceId: 'summary-metric1',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: 'count'
                }),
                submetric: metric.build({
                    property: 'count',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                }),
                showInGlance: true
            },
            {
                instanceId: 'summary-metric2',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    name: 'Update Impressions',
                    property: 'impressions'
                }),
                submetric: metric.build({
                    property: 'impressions',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                }),
                showInGlance: true
            },
            {
                instanceId: 'post-activity-by-day',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_METRIC_BAR_CHART,
                metric: RivalIQ.metric.build(dashboardModel.metric, {
                    property: 'count',
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId', 'postDay']
                }),
                metricDataType: RivalIQ.enums.dataType.INTEGER,
                height: 157,
                labels: {},
                minLeftMargin: 35
            },
            {
                instanceId: 'post-impressions-by-day',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_METRIC_BAR_CHART,
                metric: RivalIQ.metric.build(dashboardModel.metric, {
                    property: 'impressions',
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId', 'postDay'],
                    name: 'Update Impressions'
                }),
                metricDataType: RivalIQ.enums.dataType.INTEGER,
                height: 157,
                labels: {},
                minLeftMargin: 35
            }
        ];

        return filterWidgets(widgets, props);
    }

    function getFacebookWidgetDefinitions(dashboardModel, metric) {
        const props = dashboardModel.getProps();

        const widgets = [
            {
                instanceId: 'summary-metric1',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: 'count',
                    description: RivalIQ.strings.facebook_insights_posts_count_description
                }),
                submetric: metric.build({
                    property: 'count',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                }),
                showInGlance: true
            },
            {
                instanceId: 'summary-metric2',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: 'impressions',
                    name: 'Post Impressions',
                    description: RivalIQ.strings.facebook_insights_total_impressions_description
                }),
                submetric: metric.build({
                    property: 'impressions',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                }),
                showInGlance: true
            },
            {
                instanceId: 'post-activity-by-day',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_METRIC_BAR_CHART,
                metric: RivalIQ.metric.build(dashboardModel.metric, {
                    property: 'count',
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId', 'postDay']
                }),
                metricDataType: RivalIQ.enums.dataType.INTEGER,
                height: 157,
                labels: {},
                minLeftMargin: 35
            },
            {
                instanceId: 'post-impressions-by-day',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_METRIC_BAR_CHART,
                metric: RivalIQ.metric.build(dashboardModel.metric, {
                    property: 'impressions',
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId', 'postDay'],
                    name: 'Post Impressions'
                }),
                metricDataType: RivalIQ.enums.dataType.INTEGER,
                height: 157,
                labels: {},
                minLeftMargin: 35
            }
        ];

        return filterWidgets(widgets, props);
    }

    function getTwitterWidgetDefinitions(dashboardModel, metric) {
        const props = dashboardModel.getProps();

        const widgets = [
            {
                instanceId: 'summary-metric1',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    property: 'count'
                }),
                submetric: metric.build({
                    property: 'count',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                }),
                showInGlance: true
            },
            {
                instanceId: 'summary-metric2',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    name: 'Tweet Impressions',
                    property: 'impressions'
                }),
                submetric: metric.build({
                    property: 'impressions',
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                }),
                showInGlance: true
            },
            {
                instanceId: 'post-activity-by-day',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_METRIC_BAR_CHART,
                metric: RivalIQ.metric.build(dashboardModel.metric, {
                    property: 'count',
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId', 'postDay']
                }),
                metricDataType: RivalIQ.enums.dataType.INTEGER,
                height: 157,
                labels: {},
                minLeftMargin: 35
            },
            {
                instanceId: 'post-impressions-by-day',
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_METRIC_BAR_CHART,
                metric: RivalIQ.metric.build(dashboardModel.metric, {
                    property: 'impressions',
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId', 'postDay'],
                    name: 'Tweet Impressions'
                }),
                metricDataType: RivalIQ.enums.dataType.INTEGER,
                height: 157,
                labels: {},
                minLeftMargin: 35
            }
        ];

        return filterWidgets(widgets, props);
    }

    const Panel = RivalIQ.apps.Dashboard.views.Panel.extend({
        showActions: function () {
            const me = this;
            const IntervalPicker = me.getIntervalPicker();
            me.actions.show(new IntervalPicker({
                dashboardModel: me.dashboardModel
            }), {
                preventDestroy: true
            });
            me.showExportDropdown();
        },
        getIntervalPicker: function () {
            return RivalIQ.apps.Dashboard.views.IntervalDropdown;
        }
    });

    const PostActivityImpressionsWidget = RivalIQ.apps.Dashboard.models.Widget.mixin({

        getExportTitle: App.utils.insightsExportTitle,
        getExportSubtitle: App.utils.insightsExportSubtitle,
        getPptSubtitle: App.utils.insightsPptSubtitle,

        title: 'Activity & Impressions',
        description: function () {
            const me = this;

            switch (me.getProp('source')) {
                case RivalIQ.enums.sources.FACEBOOK_INSIGHTS:
                    return RivalIQ.strings.facebook_insights_post_activity_impressions_description;

                case RivalIQ.enums.sources.INSTAGRAM_INSIGHTS:
                    return RivalIQ.strings.instagram_insights_post_activity_impressions_description;

                case RivalIQ.enums.sources.LINKEDIN:
                    return RivalIQ.strings.linked_in_insights_post_activity_impressions_description;

                case RivalIQ.enums.sources.TWITTER_INSIGHTS:
                    return RivalIQ.strings.twitter_insights_post_activity_impressions_description;

                default:
                    throw new Error(`Post Activity Impressions Widget - unknown source ${me.getProp('source')}`);
            }
        },
        panelView: Panel,
        view: PostActivityImpressionsView,
        viewMore: false,

        mixins: {
            userSettingsChanged: RivalIQ.apps.Dashboard.mixins.UserSettingsChanged
        },

        filter: function () {
            const me = this;
            return RivalIQ.apps.Insights.utils.isLoadingInstagramPromotedPosts(me);
        },

        getDefaultInterval: function (baseMetric) {
            const baseConfiguration = RivalIQ.metric.build(baseMetric, {
                property: 'count',
                dimensions: ['timeAnalysisMode', 'channel', 'companyId', 'postDay']
            });

            const dailyConfiguration = RivalIQ.metric.build(baseConfiguration, {
                interval: RivalIQ.utils.timePeriod.period.day
            });

            const dailyMetric = new RivalIQ.models.Metric(dailyConfiguration);
            const dayDuration = _.last(dailyMetric.getDomainRange());

            if (dayDuration <= 31) {
                return RivalIQ.utils.timePeriod.period.day;
            }

            const monthlyConfiguration = RivalIQ.metric.build(baseConfiguration, {
                interval: RivalIQ.utils.timePeriod.period.month
            });
            const monthlyMetric = new RivalIQ.models.Metric(monthlyConfiguration);
            const monthDuration = _.last(monthlyMetric.getDomainRange()) - _.size(monthlyMetric.getIncompleteBuckets());

            if (monthDuration >= 4) {
                return RivalIQ.utils.timePeriod.period.month;
            }

            return RivalIQ.utils.timePeriod.period.week;
        },

        onUserSettingsChanged: function () {
            const me = this;

            const interval = RivalIQ.apps.Dashboard.views.IntervalDropdown.getGroupByInterval(me.getProps());
            me.setProps('interval', interval);
        },

        processProps: function (props) {
            const me = this;

            const widgets = RivalIQ.state.session.get('widgets');
            const sessionProps = _.get(widgets, [me.instanceId], {});

            _.extend(props, {
                objectType: RivalIQ.enums.insightsObjectType.post,
                submetricType: 'delta_relative'
            }, sessionProps);

            props.submetricDisplayType = 'upDownCarets';

            if (!me.metric) {
                me.metric = App.utils.createInsightsMetric(RivalIQ.enums.insightsObjectType.post, _.defaults({
                    dimensions: ['timeAnalysisMode', 'channel', 'companyId']
                }, props));
            }
            _.extend(me.metric, props);

            if (!me.isExporting()) {
                const intervalStr = RivalIQ.apps.Dashboard.views.IntervalDropdown.getGroupByInterval(props);
                me.metric.interval = props.interval = RivalIQ.apps.SocialPosts.utils.fixIntervalForMetric(intervalStr);
            }
            props.useIntervalDomainFormatting = true;

            return props;
        },

        propsToSerializeForExport: ['interval'],
        scheduledExportAdvancedSettingsEnabled: false,
        exportProps: function (props) {
            const me = this;
            _.defaults(props, {
                interval: props.defaultInterval
            });
            return me.mixins.Export.exportProps.call(me, props);
        },

        getSlides: function (overrides) {
            const me = this;

            return [
                me.buildSlide(_.defaults({
                    onlyInstanceIds: ['summary-metric1', 'summary-metric2', 'post-activity-by-day']
                }, overrides)),
                me.buildSlide(_.defaults({
                    onlyInstanceIds: ['post-impressions-by-day']
                }, overrides))
            ];
        },

        widgetDefinitions: function () {
            const me = this;

            const metric = new RivalIQ.models.MetricDefinition(me.metric);
            let widgets;

            switch (me.getProp('channel')) {
                case RivalIQ.enums.channels.INSTAGRAM:
                    widgets = getInstagramWidgetDefinitions(me, metric);
                    break;

                case RivalIQ.enums.channels.LINKEDIN:
                    widgets = getLinkedInWidgetDefinitions(me, metric);
                    break;

                case RivalIQ.enums.channels.FACEBOOK:
                    widgets = getFacebookWidgetDefinitions(me, metric);
                    break;

                case RivalIQ.enums.channels.TWITTER:
                    widgets = getTwitterWidgetDefinitions(me, metric);
                    break;

                default:
                    throw new Error(`unknown channel ${me.getProp('channel')}`);
            }

            return widgets;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSIGHTS_POSTS_ACTIVITY_IMPRESSIONS, PostActivityImpressionsWidget);
});
